<template>
    <div>
        <button
            class="btn-icon hover:bg-danger hover:border-danger"
            @click="$modal.show(`detach-model-${id}`)"
        >
            <font-awesome-icon icon="trash-alt" size="xs" />
        </button>
        <adaptive-form-modal
            :name="`detach-model-${id}`"
            :primary-button-text="buttonText || `Ta bort ${name}`"
            primary-button-class="is-danger"
            :title="`Ta bort ${name}`"
            :redirect-to="redirectRoute"
            method="delete"
            :action="actionRoute"
        >
            Vill du verkligen ta bort {{ name }}?
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            id: {
                type: [String, Number],
                required: true,
            },
            name: {
                type: String,
                default: null,
            },
            actionRoute: {
                type: String,
                required: true,
            },
            redirectRoute: {
                type: String,
                required: true,
            },
            buttonText: {
                type: String,
                required: true,
            },
        },
    };
</script>
